package com.patronat.top.core.validation

object Validator {

    // E.164 format (International): 7 to 15 digits, may start with +
    // User provided: ^\+?[1-9]\d{7,14}$
    private val PHONE_REGEX = Regex("^\\+?[1-9]\\d{7,14}\$")

    // Standard email regex
    private val EMAIL_REGEX = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}\$")

    private val OTP_REGEX = Regex("^\\d{4,8}\$")

    fun isValidPhone(phone: String): Boolean {
        return PHONE_REGEX.matches(phone)
    }

    fun isValidEmail(email: String): Boolean {
        return EMAIL_REGEX.matches(email)
    }

    fun isValidOtp(code: String): Boolean {
        return OTP_REGEX.matches(code)
    }

    fun isValidName(name: String): Boolean {
        return name.isNotBlank() && name.length >= 2
    }
}